export default {
    typ: '帳號類型',
    employee: 'Sokuji 帳號身份',
    eml: '帳號(E-mail)',
    nam: '姓名',
    idNumber: '身分證號碼',
    pJ_NO: '專案代碼 (2碼，英文或數字)',
    deP_SNO: '所屬部門',
    boS_SNO: '直屬主管',
    mem: '備註',

    stafF_BNK_BOO: '薪轉銀行',
    stafF_BNK_DOO: '薪轉分行',
    stafF_BNK_ACC: '薪轉帳號',
    stafF_BNK_TPC: '薪轉帳號戶名',

    grP_NO: '身份功能',
};
